<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="pakbonnummer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pakbonnummer </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbonnummer}} </td>
    </ng-container>

	<ng-container matColumnDef="datumPakbon">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-10> Datum pakbon </th>
        <td mat-cell *matCellDef="let row"> {{row.datumPakbon | date}} </td>
    </ng-container>

    <ng-container matColumnDef="groep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Groep </th>
        <td mat-cell *matCellDef="let row"> {{row.project.projectgroep.afdeling}} </td>
    </ng-container>

    <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
        <td mat-cell *matCellDef="let row"> {{row.project.code}} </td>
    </ng-container>

    <ng-container matColumnDef="klant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Klant </th>
        <td mat-cell *matCellDef="let row"> {{row.project.relatie.naam1}} </td>
    </ng-container>

    <ng-container matColumnDef="referentieKlant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Referentie </th>
        <td mat-cell *matCellDef="let row"> {{row.project?.referentieKlant}} </td>
    </ng-container>

	<ng-container matColumnDef="verzendtarief">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verzendtarief </th>
        <td mat-cell *matCellDef="let row"> {{row.verzendtarief?.omschrijving}} </td>
    </ng-container>

	<ng-container matColumnDef="verzendbedrag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-8> Verzendbedrag </th>
        <td mat-cell *matCellDef="let row"> € {{row.verzendbedrag?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="opmerking">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Opmerking </th>
        <td mat-cell *matCellDef="let row"> {{row.opmerking}} </td>
    </ng-container>
   
    <ng-container matColumnDef="aantalPakbonregels">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Aantal Regels </th>
        <td mat-cell *matCellDef="let row"> {{row.aantalPakbonregels}} </td>
    </ng-container>

    <ng-container matColumnDef="wachtOpPrijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-8> Wacht op Prijs </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.wachtOpPrijs">done</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="proFormaTerGoedkeuring">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-6> Proforma<br>Goedkeuring </th>
        <td mat-cell *matCellDef="let row"><center><mat-icon *ngIf="row.project?.relatie?.proFormaTerGoedkeuring">done</mat-icon></center></td>
    </ng-container>
   
    <ng-container matColumnDef="proFormaVoorInkoop">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-6> Proforma<br>Inkoop </th>
        <td mat-cell *matCellDef="let row"><center><mat-icon *ngIf="row.project?.relatie?.proFormaVoorInkoop">done</mat-icon></center></td>
    </ng-container>
   
    <ng-container matColumnDef="hasProFormaFactuur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-6> Proforma<br>Factuur </th>
        <td mat-cell *matCellDef="let row"><center><mat-icon *ngIf="row.hasProFormaFactuur">done</mat-icon></center></td>
    </ng-container>
   
</mg-table>
